// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrapper-buttons{\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 1rem;\n}\n\n", ""]);
// Exports
module.exports = exports;
